// Generated from ContestAttempt's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type ContestAttemptCollectionFilterGroups
  = | {
    readonly assign: Iri
  }
  | {
    readonly judge: Iri
  }

export const contestAttemptCollectionFilterMapping: FilterDefinitionMapping<ContestAttemptCollectionFilterGroups> = {
  assign: 'assign',
  judge: 'judge',
}

export type ContestAttemptCollectionSort = 'registeredAt' | 'assign.participant.lastName' | 'assign.participant.bibNumber' | 'assign.routeAssign.name'
